import React from 'react';
import DropDown from '../DropDown';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  useGetClassesMutation
} from '../../features/authentication/authApiSlice';
import FERPA from '../FERPA/FerpaComponent';
import ProgressButton from '../ProgressButton';

const HeaderToolbarContent = ({ reportTitle, exportHandler, printHandler, setSelectedClassName, hideClassDropdown, onClassChange, isExporting, isDownloading, hideBackButton, backButtonOnClick, isPageLoading, hideFerpa, info, headerDetails}) => {

  const navigate = useNavigate();
  const [selectedClassId, setSelectedClassId] = React.useState(-1);
  const [classList, setClassList] = React.useState([]);
  const [getAllClasses] = useGetClassesMutation();

  const handleClassChange = (e) => {
    const selectedClassId = parseInt(e.target.value);
    const selectedOption = classList.find((option) => option.id === selectedClassId);
    setSelectedClassName(selectedOption.name);
    setSelectedClassId(selectedClassId);
    onClassChange(selectedClassId);
  };

  async function loadClasses()
  {
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    setClassList([
      {
        name: 'All Classes',
        id: -1,
        description: 'All Classes',
        isChecked: true
      },
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        description: item.className,
        isChecked: true
      }))
    ]);
  }

  React.useEffect(() => {
    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
      setClassList([
        {
          name: 'All Classes',
          id: -1,
          description: 'All Classes',
          isChecked: true
        },
        ...classes.map((item) => ({
          name: item.className,
          id: item.classID,
          description: item.className,
          isChecked: true
        }))
      ]);
    }else if(!hideClassDropdown)
    {
      loadClasses();
    }
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className='d-flex gap-2'>
          <h1 className='mb-4'>{reportTitle}</h1>
          {info}
        </div>
        
        <div id="buttonGroup" className="ReportToolbarBtn gap-3 align-items-center">
          {!hideFerpa &&
            <div className="d-flex me-3 align-items-center">
              <FERPA />
            </div>
          }
          {!hideBackButton &&
            <button id="back_button" onClick={() => backButtonOnClick? backButtonOnClick() : navigate(-1)} className="btn btn-width btn-castleWhite">
              Back
            </button>
          }
          {exportHandler &&
            <button id="export_button" disabled={isExporting || isPageLoading} onClick={exportHandler} className="btn btn-width btn-castleOrange p-0">
              {isExporting ? 'Exporting...' : 'Export'}
            </button>
          }
          {printHandler &&
            <ProgressButton
              isLoading={isDownloading}
              onClick={printHandler}
              loadingLabel="Generating PDF"
              label="Print to PDF"
              className="btn btn-castleRed"
              expectedDuration={1500}
            />
          }
        </div>
      </div>
      {headerDetails}
      {!hideClassDropdown && <div id="dropdown_container" className="d-flex flex-column justify-content-start w-25">
        Class
        <DropDown
          value={classList}
          selectedValue={selectedClassId}
          onChangeHandler={handleClassChange}
        />
      </div>  
      }    
    </>
  );
};

HeaderToolbarContent.propTypes = {
  reportTitle : PropTypes.string.isRequired,
  exportHandler: PropTypes.func,
  printHandler: PropTypes.func,
  setSelectedClassName: PropTypes.func,
  hideClassDropdown: PropTypes.bool,
  onClassChange: PropTypes.func,
  isExporting: PropTypes.bool,
  isDownloading: PropTypes.bool,
  hideBackButton: PropTypes.bool,
  backButtonOnClick: PropTypes.func,
  isPageLoading:  PropTypes.bool,
  hideFerpa:  PropTypes.bool,
  info : PropTypes.func,
  headerDetails : PropTypes.func
};
  
export default HeaderToolbarContent;